export default __webpack_public_path__ + "static/media/CLOSE_CONTAINER.4be3da42.svg";